import { render } from "./ReplaceDevicePopup.vue?vue&type=template&id=664b58f8&ts=true"
import script from "./ReplaceDevicePopup.vue?vue&type=script&lang=ts"
export * from "./ReplaceDevicePopup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__